<template>
  <div class="space-y-2">
    <p>
      Cookies are small text files that websites store on your device through your browser. They help websites recognize your device and maintain essential functionality, such as login sessions and secure access.
    </p>
    <p>
      We use cookies only where necessary to provide a secure and consistent experience for registered users.
    </p>
  </div>
</template>